function bulletList (bullet) {
    let ul = document.getElementById('bulletList');
    let resp = bullet.replaceAll('<p>', '').split('</p>');
    let bulletList = Object.values(resp);
    bulletList.forEach(element => {
        if ( element !== null && element !== '') {
            let li = document.createElement('li');
            li.setAttribute('class', 'highlight-bulletList__item')
            li.innerText = element;
            ul.appendChild(li);
        }
    });
};